import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { InViewportDirective } from 'libs/shared/util-common/src/lib/directives/in-viewport.directive';
import { IsMobileService } from 'libs/shared/util-common/src/lib/directives/is-mobile.service';
import { SpinnerComponent } from 'shared/ui-common';

import { NoResultsComponent } from '../../../../ui-common/src/lib/components/no-results/no-results.component';
import {
  GuidelineSearchResultItem,
  GuidelineSearchResultItemSelectedEvent,
  GuidelineSearchResultItemComponent,
} from '../guideline-search-result-item/guideline-search-result-item.component';

@Component({
  selector: 'tt-guideline-search-result-list',
  standalone: true,
  imports: [TranslocoModule, GuidelineSearchResultItemComponent, SpinnerComponent, InViewportDirective, NoResultsComponent],
  templateUrl: './guideline-search-result-list.component.html',
  styleUrls: ['./guideline-search-result-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidelineSearchResultListComponent {
  protected isMobileService = inject(IsMobileService);

  @Input() public searchResults: GuidelineSearchResultItem[] = [];
  @Input() public loading = false;
  @Input() public loadingMore = false;
  @Input() public error: string | null = null;
  @Input() public searchTerm: string | null = null;
  @Input() public hasMoreResults = false;

  @Output() public itemSelected = new EventEmitter<GuidelineSearchResultItemSelectedEvent>();
  @Output() public loadNextPage = new EventEmitter<void>();
  @Output() public clearSearch = new EventEmitter<void>();
}
